import { useCallback } from "react";

import type * as FormModelType from "@/components/features/setup/model/type";

export const useActions = (
	viewModel: FormModelType.SetupFormModel["ViewModel"],
	onSetViewModel: (viewModel: FormModelType.SetupFormModel["ViewModel"]) => void,
	onCreateHotel: () => void,
) => {
	const handleChangeHotelName = useCallback(
		(value: string) => {
			onSetViewModel({
				...viewModel,
				hotelName: {
					...viewModel.hotelName,
					value,
				},
			});
		},
		[viewModel, onSetViewModel],
	);

	const handleChangeEmail = useCallback(
		(value: string) => {
			onSetViewModel({
				...viewModel,
				hotelEmailAddress: {
					...viewModel.hotelEmailAddress,
					value,
				},
			});
		},
		[viewModel, onSetViewModel],
	);

	const handleChangeTotalRoomNum = useCallback(
		(value: number | undefined) => {
			onSetViewModel({
				...viewModel,
				totalRoomNum: {
					...viewModel.totalRoomNum,
					value: (typeof value === "undefined" ? undefined : value) as number, // 入力した値を全て消せるように未入力（undefined）の状態を許容している。← この場合Zodのバリデーションが出る
				},
			});
		},
		[viewModel, onSetViewModel],
	);

	const handleClickCreateHotel = useCallback(() => {
		onCreateHotel();
	}, [onCreateHotel]);

	return {
		handleChangeHotelName,
		handleChangeEmail,
		handleChangeTotalRoomNum,
		handleClickCreateHotel,
	};
};
